import VueRouter from 'vue-router';

import Navigation from './components/Navigation.vue';
import Communications from './components/Communications.vue';
import Ct from './components/Ct.vue';
import Load from './components/Load.vue';
import Login from './components/Login.vue';
import General from './components/General.vue';
import Voltage from './components/Voltage.vue';
import Pulse from './components/Pulse.vue';
import Alarm from './components/Alarm.vue';
import Trends from './components/Trends.vue';
import OdoMeter from './components/OdoMeter.vue';
import Report from './components/Report.vue';
import Log from './components/Log.vue';
import AlarmLog from './components/AlarmLog.vue';
import System from './components/System.vue';
import Export from './components/Export.vue';
import Help from './components/Help.vue';

import NotImplemented from './components/BaseNotImplemented.vue';
import BaseLiveGraph from './components/BaseLiveGraph.vue';
import BaseHistoryGraph from './components/BaseHistoryGraph.vue';

import * as auth from './auth';

const router = new VueRouter({
  routes: [
    {
      path: '/',
      component: Navigation,
      meta: { requiresAuth: true },
      children: [
        { path: 'general', name: 'home', component: General },
        { path: 'voltage', name: 'Voltage', component: Voltage },
        { path: 'load', component: Load },
        { path: 'ct', component: Ct },
        { path: 'communications', component: Communications },
        { path: 'pulse', component: Pulse },
        { path: 'alarm', component: Alarm },
        { path: 'report', component: Report },
        { path: 'baselivegraphtest', component: BaseLiveGraph },
        { path: 'basehistorygraphtest', component: BaseHistoryGraph },
        { path: 'trends', component: Trends },
        { path: 'harmonics', component: NotImplemented },
        { path: 'waveform', component: NotImplemented },
        { path: 'odometer', component: OdoMeter },
        { path: 'log', component: Log },
        { path: 'alarmlog', component: AlarmLog },
        { path: 'system', component: System },
        { path: 'export', component: Export },
        { path: 'help', component: Help },
      ],
    },
    { path: '/login', name: 'login', component: Login },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (auth.getAccessToken() == null) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
